export default "__VITE_ASSET__q5_dZWBo__"